function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import * as React from "react";
import { IconButton, SpinnerIcon } from "@bolteu/kalep-react";
import { UploadArea, UploadHelperText } from "@bolteu/kalep-react/build/components/Upload/UploadArea";
import { UploadAttachments } from "@bolteu/kalep-react/build/components/Upload/UploadAttachments";
import CheckCircleOutlined from "@bolteu/kalep-react-icons/dist/CheckCircleOutlined";
import Upload from "@bolteu/kalep-react-icons/dist/Upload";
export function UploadField(props) {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    file = _React$useState2[0],
    setFile = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isUploadInProgress = _React$useState4[0],
    setUploadInProgress = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isUploaded = _React$useState6[0],
    setIsUploaded = _React$useState6[1];
  var onFileAttached = React.useCallback(function (files) {
    setFile(files[0]);
    setIsUploaded(false);
  }, []);
  var validatorResults = props.validatorResults,
    onChange = props.onChange,
    onUpload = props.onUpload;
  var validationError = validatorResults === null || validatorResults === void 0 ? void 0 : validatorResults[0];
  var startUpload = React.useCallback(function () {
    if (!file) {
      return;
    }
    setUploadInProgress(true);
    onUpload({
      file: file
    }).then(function (result) {
      onChange({
        value: result
      });
      setUploadInProgress(false);
      setIsUploaded(true);
    })["catch"](function (e) {
      setUploadInProgress(false);
      // Throw any errors from upload up so the consumer can handle them.
      throw e;
    });
  }, [setUploadInProgress, onChange, file, onUpload]);
  var renderEndSlot = React.useCallback(function () {
    return /*#__PURE__*/React.createElement(EndSlot, {
      startUpload: startUpload,
      isUploadInProgress: isUploadInProgress,
      isUploaded: isUploaded
    });
  }, [startUpload, isUploadInProgress, isUploaded]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UploadArea, {
    label: props.label || props.name,
    name: props.name,
    disabled: props.disabled || isUploadInProgress,
    required: props.required,
    fullWidth: props.fullWidth,
    onFilesAttached: onFileAttached,
    filesAttached: !!file
  }), /*#__PURE__*/React.createElement(UploadAttachments, {
    files: file ? [file] : [],
    renderEndSlot: renderEndSlot,
    fullWidth: props.fullWidth
  }), /*#__PURE__*/React.createElement(UploadHelperText, {
    appearance: validationError ? "error" : undefined
  }, validationError ? validationError.error : props.helperText));
}
function EndSlot(_ref) {
  var startUpload = _ref.startUpload,
    isUploadInProgress = _ref.isUploadInProgress,
    isUploaded = _ref.isUploaded;
  if (isUploaded) {
    return /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "Uploaded",
      disabled: true,
      icon: /*#__PURE__*/React.createElement(CheckCircleOutlined, null)
    });
  }
  if (isUploadInProgress) {
    return /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "Uploading",
      disabled: true,
      icon: /*#__PURE__*/React.createElement(SpinnerIcon, {
        className: "animate-spin"
      })
    });
  }
  return /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Upload",
    onClick: startUpload,
    icon: /*#__PURE__*/React.createElement(Upload, null)
  });
}